<!--Start Back To Top Button-->
<a href="javascript:void(0);" class="back-to-top" (click)="scrollTop()"><i class="fa-solid fa-arrow-up"></i></a>

<!--Version info badge, only shown when ENABLE_VERSION_INFO is set-->
<div class="version-info-badge" *ngIf="versionInfo?.enabled">
  web {{ versionInfo?.website?.commit || '?' }} &middot; api {{ versionInfo?.api?.commit || '?' }}
</div>
